import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  Button,
  Card,
  Chip,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TextField,
  Typography,
} from "@mui/material";
import {
  Unstable_NumberInput as BaseNumberInput,
  NumberInputProps,
  numberInputClasses,
} from "@mui/base/Unstable_NumberInput";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch, { SwitchProps } from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import { useEffect, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { format } from "date-fns";
import dayjs, { Dayjs } from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  CreateAppraisalForm,
  ShowForms,
  createThreeSixtyForm,
  viewHierarchicalForm,
} from "../../../Service/Apis";
import {
  ToastVariant,
  useCustomToast,
} from "../../../components/Methods/SnackBar";
import Footer from "../../../components/Page Component/Footer";
import Navbar from "../../../components/Page Component/Navbar";
import useAxiosInterceptor from "../../../components/layout/AxiosInstance";
import { setInPageLoading, setIsLoading } from "../../../store/LoadingSlice";
import { RootState } from "../../../store/Store";
import {
  FetchDataFailureAction,
  FetchDataSuccessAction,
  fetchData,
  postData,
} from "../../../store/actions";
import { date } from "../AddForm";
import NumberInput from "../../../components/NumberInput/NumberInput";

interface ThreeSixtyForm {
  categories: {
    category: string;
    questions: {
      // question_id: string;
      question: string;
      answer_type: string;
      answer_choices: {
        answer_value: string;
        answer_point: number;
        // option_id: string;
      }[];
    }[];
  }[];
}

interface OptionValue {
  [categoryIndex: number]: {
    [questionIndex: number]: {
      value: string;
    };
  };
}

interface AnswerWeight {
  [categoryIndex: number]: {
    [questionIndex: number]: {
      value: number;
    };
  };
}

interface AnswerChoicesError {
  [categoryIndex: number]: {
    [questionIndex: number]: {
      value: boolean;
    };
  };
}

const initialOptionValue: OptionValue = {};
const initialAnswerWeight: AnswerWeight = {};
const initialAnswerChoice: AnswerChoicesError = {};

const initialState: ThreeSixtyForm = {
  categories: [
    {
      category: "",
      questions: [
        {
          question: "",
          answer_type: "multichoice",
          answer_choices: [],
        },
      ],
    },
  ],
};

const ThreeSixtyForm = () => {
  const [formContent, setFormContent] = useState<ThreeSixtyForm>(initialState); //To manage the appraisal form content.

  const [importForm, setImportForm] = useState<boolean>(false);
  const [form, setForm] = useState([]);
  const [formId, setFormId] = useState<string>("");

  const [formName, setFormName] = useState<string>("");
  const [formDescription, setFormDescription] = useState<string>("");
  const [managerResponseVisibility, setManagerResponseVisibility] =
    useState<boolean>(true);

  const [optionValue, setOptionValue] =
    useState<OptionValue>(initialOptionValue);
  const [answerWeight, setAnswerWeight] =
    useState<AnswerWeight>(initialAnswerWeight);
  const [forceUpdateKey, setForceUpdateKey] = useState(0);

  const [empDate, setEmpDate] = useState<Dayjs | null>(dayjs(`${date}`));
  const [managerDate, setManagerDate] = useState<Dayjs | null>(
    empDate?.add(1, "day") as Dayjs
  );
  const [deleteSectionIs, setDeleteSectionIs] = useState<number | null>(null); //To open confirmation box for deleting section.
  const [deleteCategoryIs, setDeleteCategoryIs] = useState<{
    categoryIndex: number | null;
  }>({ categoryIndex: null }); //To open confirmation box for deleting category.
  const [deleteQuestionIs, setDeleteQuestionIs] = useState<{
    categoryIndex: number | null;
    questionIndex: number | null;
  }>({ categoryIndex: null, questionIndex: null }); //To open confirmation box for deleting question.

  const [answerChoicesError, setAnswerChoicesError] =
    useState<AnswerChoicesError>(initialAnswerChoice);

  const [flag, setFlag] = useState<boolean>(false); //To display message for rating validation after the form submission.

  const axiosInstance = useAxiosInterceptor();
  const showToast = useCustomToast();

  const dispatch = useDispatch();

  const isloading = useSelector((state: any) => state.loading.isLoading);

  const token = localStorage.getItem("token");

  const Navigate = useNavigate();

  const dispatch2: ThunkDispatch<
    RootState,
    null,
    FetchDataSuccessAction | FetchDataFailureAction
  > = useDispatch();

  const handleOpenImportForm = (e: any) => {
    setImportForm(true);
  };

  const handleShowToast = (
    message: string,
    variant: ToastVariant,
    isCloseable: boolean
  ) => {
    showToast(message, variant, isCloseable);
  };

  const handleCloseImportForm = () => {
    setImportForm(false);
  };

  const handleOpenSectionDelete = (sectionIndex: number) => {
    setDeleteSectionIs(sectionIndex);
  };

  const handleCloseSectionDelete = () => {
    setDeleteSectionIs(null);
  };

  const handleOpenCategoryDelete = (categoryIndex: number) => {
    setDeleteCategoryIs({
      categoryIndex: categoryIndex,
    });
  };

  const handleCloseCategoryDelete = () => {
    setDeleteCategoryIs({ categoryIndex: null });
  };

  const handleOpenQuestionDelete = (
    categoryIndex: number,
    questionIndex: number
  ) => {
    setDeleteQuestionIs({
      categoryIndex: categoryIndex,
      questionIndex: questionIndex,
    });
  };

  const handleCloseQuestionDeleter = () => {
    setDeleteQuestionIs({
      categoryIndex: null,
      questionIndex: null,
    });
  };

  const addCategory = () => {
    const newCategory = {
      category: "",
      questions: [
        {
          question: "",
          answer_type: "multichoice",
          answer_choices: [],
        },
      ],
    };

    // Create a copy of the current state
    const updatedFormContent = { ...formContent };

    // Add the new category to the copy
    updatedFormContent.categories.push(newCategory);

    // Update the state with the new form content
    setFormContent(updatedFormContent);
  };

  const addQuestion = (
    categoryIndex: number
    // questionType: string
  ) => {
    const updatedCategory = {
      ...formContent.categories[categoryIndex],
    };
    const newQuestion = {
      //   question_id: "",
      question: "",
      answer_type: "multichoice",
      answer_choices: [], // Remove the initial null option
    };

    updatedCategory.questions.push(newQuestion);

    const updatedFormContent = { ...formContent };
    updatedFormContent.categories[categoryIndex] = updatedCategory;

    setFormContent(updatedFormContent);
  };

  const deleteQuestion = (categoryIndex: number, questionIndex: number) => {
    const totalQuestions =
      formContent.categories[categoryIndex].questions.length;
    if (questionIndex > -1 && totalQuestions > 1) {
      const updatedCategory = {
        ...formContent.categories[categoryIndex],
      };

      updatedCategory.questions.splice(questionIndex, 1);

      const updatedFormContent = { ...formContent };
      updatedFormContent.categories[categoryIndex] = updatedCategory;

      setFormContent(updatedFormContent);
    } else if (totalQuestions <= 1) {
      handleShowToast("Cannot Delete Last Question.", "info", true);
    }
  };

  const editQuestionType = (
    categoryIndex: number,
    questionIndex: number,
    questionType: string
  ): void => {
    const updatedFormContent = { ...formContent };
    const question =
      updatedFormContent.categories[categoryIndex].questions[questionIndex];
    question.answer_type = questionType;

    setFormContent(updatedFormContent);
  };

  const handleSetOptionValue = (
    categoryIndex: number,
    questionIndex: number,
    value: string
  ) => {
    setOptionValue((prevOptionValue) => {
      // Create a copy of the current state to avoid modifying it directly
      const updatedOptionValue = { ...prevOptionValue };

      // Check if the sectionIndex exists in the state

      // Check if the categoryIndex exists in the state
      if (!updatedOptionValue.hasOwnProperty(categoryIndex)) {
        updatedOptionValue[categoryIndex] = {};
      }

      // Update the value for the specified questionIndex
      updatedOptionValue[categoryIndex][questionIndex] = {
        value: value,
      };

      // Return the updated state
      return updatedOptionValue;
    });
  };

  const isDuplicate = async (value: number): Promise<boolean> => {
    for (const categoryIndex in answerWeight) {
      for (const questionIndex in answerWeight[categoryIndex]) {
        const currentValue = answerWeight[categoryIndex][questionIndex].value;
        if (currentValue === value) {
          return true; // Duplicate found
        }
      }
    }
    return false; // No duplicate found
  };

  const handleSetAnswerChoiceWeight = async (
    categoryIndex: number,
    questionIndex: number,
    value: number
  ) => {
    setAnswerWeight((prevOptionValue) => {
      return {
        ...prevOptionValue,
        [categoryIndex]: {
          ...prevOptionValue[categoryIndex],
          [questionIndex]: {
            value: value,
          },
        },
      };
    });
  };

  //To Keep Minimum 2 fields for one mulltiple choice question validation.
  const handleAnswerChoice = (
    categoryIndex: number,
    questionIndex: number,
    value: number
  ) => {
    setAnswerChoicesError((prevAnswerError) => {
      const updatedAnswerError = { ...answerChoicesError };
      const categoryError = updatedAnswerError[categoryIndex] || {};
      const questionError = categoryError[questionIndex] || {
        value: false,
      };

      questionError.value = value < 2;

      categoryError[questionIndex] = questionError;
      updatedAnswerError[categoryIndex] = categoryError;

      return updatedAnswerError;
    });
  };

  const addOption = (categoryIndex: number, questionIndex: number) => {
    const updatedFormContent = { ...formContent };
    const question =
      updatedFormContent.categories[categoryIndex].questions[questionIndex];
    // Check for duplicate answerWeight value within the question
    const isDuplicateValue = question.answer_choices.some(
      (choice) =>
        choice.answer_point ===
        answerWeight?.[categoryIndex]?.[questionIndex]?.value
    );

    if (isDuplicateValue) {
      // Handle duplicate answerWeight value error (e.g., display an error message)
      handleShowToast("Please enter a different value", "error", true);
      return;
    }
    const newOption = {
      answer_value: optionValue?.[categoryIndex]?.[questionIndex]?.value, //newOptionValue,
      option_id: "", // Add the necessary logic to generate a unique option ID
      answer_point:
        answerWeight?.[categoryIndex]?.[questionIndex]?.value === undefined
          ? 0
          : answerWeight?.[categoryIndex]?.[questionIndex]?.value,
    };
    setFormContent((prevFormContent) => {
      const updatedFormContent = { ...prevFormContent };
      question.answer_choices.push(newOption);
      return updatedFormContent;
    });

    handleSetOptionValue(categoryIndex, questionIndex, "");

    handleSetAnswerChoiceWeight(categoryIndex, questionIndex, 0);

    setForceUpdateKey((prevKey) => prevKey + 1);

    handleAnswerChoice(
      categoryIndex,
      questionIndex,
      question.answer_choices.length
    );
  };

  const deleteOption = (
    categoryIndex: number,
    questionIndex: number,
    optionIndex: number
  ) => {
    const updatedFormContent = { ...formContent };
    const question =
      updatedFormContent.categories[categoryIndex].questions[questionIndex];
    question.answer_choices.splice(optionIndex, 1);
    setFormContent(updatedFormContent);
    handleAnswerChoice(
      categoryIndex,
      questionIndex,
      question.answer_choices.length
    );
  };

  const deleteCategory = (categoryIndex: number) => {
    const totalCategories = formContent.categories.length;
    if (categoryIndex > -1 && totalCategories > 1) {
      const updatedFormContent = { ...formContent };
      updatedFormContent.categories.splice(categoryIndex, 1);
      setFormContent(updatedFormContent);
    } else if (totalCategories <= 1) {
      handleShowToast("Cannot Delete Last Category", "info", true);
    }
  };

  const handleCategoryNameChange = (
    categoryIndex: number,
    value: string
  ): void => {
    const updatedFormContent = { ...formContent };
    updatedFormContent.categories[categoryIndex].category = value;

    setFormContent(updatedFormContent);
  };

  const handleQuestionChange = (
    categoryIndex: number,
    questionIndex: number,
    value: string
  ): void => {
    const updatedFormContent = { ...formContent };
    updatedFormContent.categories[categoryIndex].questions[
      questionIndex
    ].question = value;

    setFormContent(updatedFormContent);
  };

  //To create a form.
  const handleSubmit = async (e: any) => {
    e.preventDefault();

    let isAnyAnswerChoiceError = false;

    //Check for an error for answer choices have minimum 2 options show error and return.
    Object.values(answerChoicesError).forEach((categories) => {
      Object.values(categories).forEach((questions: any) => {
        Object.values(questions).forEach((error: any) => {
          if (error.value) {
            isAnyAnswerChoiceError = true;
          }
        });
      });
    });

    if (isAnyAnswerChoiceError) {
      setFlag(true);
      return;
    }

    const { categories } = formContent;
    var data = {
      form_name: formName,
      form_description: formDescription,
      employee_deadline: empDate ? format(empDate.toDate(), "yyyy-MM-dd") : "",
      manager_deadline: managerDate
        ? format(managerDate.toDate(), "yyyy-MM-dd")
        : "",
      teams: [],
      is_hierarchical: false,
      is_360: true,
      // manager_fields_visible: managerResponseVisibility,
      sections: [
        {
          categories,
        },
      ],
    };
    // API call for creating a form.
    try {
      const response = await dispatch2(
        postData(`${createThreeSixtyForm}`, data)
      )
        .then((response) => {
          setFormContent(initialState);
          handleShowToast(
            `${formName} Created Successfully !`,
            "success",
            true
          );
          setFormContent(initialState);
          // dispatch(postDataSuccess(null));
          Navigate("/createdforms");
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  //Import form
  // get list of all forms.
  useEffect(() => {
    const fetchForms = async () => {
      try {
        dispatch(setIsLoading(true));
        const response = await dispatch2(fetchData(`${ShowForms}?is_360=True`));
        setForm(response as any);
        dispatch(setIsLoading(false));
      } catch (error) {
        console.log(error);
      }
    };
    fetchForms();
  }, []);

  // View particular form.
  useEffect(() => {
    dispatch(setIsLoading(true));
    const response = axiosInstance
      .get(`${viewHierarchicalForm}${formId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (formId !== "") {
          setFormContent({
            ...formContent,
            // sections: res.data[0].sections.map((section: any) => ({
            //   section: section.section,
            //   section_id: section.section_id,
            categories: res.data[0].sections[0].categories.map(
              (category: any) => ({
                category_id: category.category_id,
                category: category.category,
                questions: category.questions.map((question: any) => ({
                  question_id: question.question_id,
                  question: question.question,
                  answer_type: question.answer_type,
                  answer_choices: question.answer_choices.map(
                    (choice: any) => ({
                      answer_value: choice.answer_value,
                      option_id: choice.option_id,
                      answer_point: choice.answer_point,
                    })
                  ),
                })),
              })
            ),
          });
          setFormName(res.data[0].form_name);
          setFormDescription(res.data[0].form_description);
        }
        dispatch(setIsLoading(false));
      })
      .catch((error) => {
        dispatch(setIsLoading(false));
        console.log(error);
      });
  }, [formId]);

  if (isloading) {
    return (
      <>
        <CircularProgress
          size={50}
          sx={{ top: 150, left: "50%", position: "relative" }}
        />
      </>
    );
  }

  return (
    <>
      <Container sx={{}}>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Box component="form" onSubmit={handleSubmit}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "right",
                m: 2,
                // width: "100%",
              }}
            >
              {/* <Box>
                <FormControlLabel
                  control={
                    <IOSSwitch
                      sx={{ m: 1 }}
                      checked={managerResponseVisibility}
                      onChange={(e) =>
                        setManagerResponseVisibility(e.target.checked)
                      }
                    />
                  }
                  label="Manager Response Visibility"
                />
              </Box> */}
              <Box sx={{ display: "flex", justifyContent: "right" }}>
                <Button
                  id="import"
                  size="small"
                  variant="contained"
                  onClick={handleOpenImportForm}
                  sx={{ m: 0.5 }}
                >
                  Import
                </Button>
                {formId !== "" && (
                  <Button
                    id="reset"
                    size="small"
                    sx={{ m: 0.5 }}
                    onClick={() => {
                      dispatch(setInPageLoading(true));
                      setFormContent(initialState);
                      setFormName("");
                      setFormDescription("");
                      setFormId("");
                      dispatch(setInPageLoading(false));
                    }}
                  >
                    Reset
                  </Button>
                )}
              </Box>
              <Dialog
                open={importForm}
                fullScreen
                onClose={handleCloseImportForm}
              >
                <DialogTitle
                  sx={{ display: "flex", justifyContent: "center", m: 2 }}
                >
                  <Typography variant="h4">Existing Forms </Typography>
                </DialogTitle>
                <DialogContent>
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead className="header-background">
                        <TableCell
                          sx={{ textAlign: "center", fontWeight: "bold" }}
                        >
                          Sr. No.
                        </TableCell>
                        <TableCell
                          sx={{ textAlign: "center", fontWeight: "bold" }}
                        >
                          Form Name
                        </TableCell>
                        <TableCell
                          sx={{ textAlign: "center", fontWeight: "bold" }}
                        >
                          Employee Deadline
                        </TableCell>
                        <TableCell
                          sx={{ textAlign: "center", fontWeight: "bold" }}
                        >
                          Manager Deadline
                        </TableCell>
                        <TableCell
                          sx={{ textAlign: "center", fontWeight: "bold" }}
                        >
                          Action
                        </TableCell>
                      </TableHead>
                      {form.map((form: any, index) => {
                        return (
                          <TableBody>
                            <TableCell sx={{ textAlign: "center" }}>
                              {index + 1 + "."}
                            </TableCell>
                            <TableCell sx={{ textAlign: "center" }}>
                              {form.form_name}
                            </TableCell>
                            <TableCell sx={{ textAlign: "center" }}>
                              {form.employee_deadline}
                            </TableCell>
                            <TableCell sx={{ textAlign: "center" }}>
                              {form.manager_deadline}
                            </TableCell>
                            <TableCell sx={{ textAlign: "center" }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Button
                                  size="small"
                                  onClick={(e) => {
                                    setFormId(form.form_id);
                                    handleCloseImportForm();
                                  }}
                                >
                                  Select
                                </Button>
                              </Box>
                            </TableCell>
                          </TableBody>
                        );
                      })}
                    </Table>
                  </TableContainer>
                </DialogContent>
                <DialogActions sx={{ p: 2, m: 2 }}>
                  <Box sx={{ display: "flex", justifyContent: "right" }}>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={handleCloseImportForm}
                    >
                      Close
                    </Button>
                  </Box>
                </DialogActions>
              </Dialog>
            </Box>
            <Box sx={{ width: "75vw" }}>
              <Card
                elevation={11}
                sx={{
                  m: 2,
                  p: 2,
                  display: "flex",
                  justifyContent: "center",
                  // width: {
                  //   xs: "fit-content",
                  //   sm: "fit-content",
                  //   md: "100%",
                  // },
                  boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)", // Add boxShadow here
                  border: "1px solid #ccc",
                }}
              >
                <Box sx={{ width: "90%" }}>
                  <TextField
                    id="form_name"
                    name="form_name"
                    required
                    fullWidth
                    multiline
                    maxRows={4}
                    sx={{ overflow: "auto", p: 1 }}
                    variant="standard"
                    size="small"
                    placeholder="Form Heading"
                    value={formName}
                    onChange={(e) => {
                      setFormName(e.target.value);
                    }}
                  />
                  <TextField
                    id="description"
                    fullWidth
                    required
                    variant="standard"
                    size="small"
                    placeholder="Form Description"
                    multiline
                    maxRows={4}
                    minRows={2}
                    sx={{ overflow: "auto", p: 1 }}
                    value={formDescription}
                    onChange={(e) => {
                      setFormDescription(e.target.value);
                    }}
                  />
                </Box>
              </Card>
            </Box>
            <Box>
              <Box>
                {formContent.categories.map((category, categoryIndex) => {
                  return (
                    <Card
                      key={categoryIndex}
                      elevation={11}
                      sx={{
                        m: 2,
                        p: 2,
                        flex: 1,
                        flexShrink: 1,
                        // width: {
                        //   xs: "fit-content",
                        //   sm: "fit-content",
                        //   md: "100%",
                        // },
                        boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)", // Add boxShadow here
                        border: "1px solid #ccc",
                      }}
                    >
                      <Box sx={{ m: 4 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            p: 0,
                          }}
                        >
                          <InputLabel
                            sx={{ width: "15rem", fontWeight: "bold" }}
                            htmlFor="category_name"
                          >
                            Category{" "}
                            {String.fromCharCode(
                              categoryIndex + "A".charCodeAt(0)
                            )}{" "}
                            :
                            {/* {String.fromCharCode(
                      categoryIndex + "a".charCodeAt(0)
                    ) + ")"}{" "} */}
                          </InputLabel>
                          <TextField
                            name="category_name"
                            fullWidth
                            required
                            multiline
                            maxRows={4}
                            sx={{ overflow: "auto" }}
                            value={category.category}
                            variant="standard"
                            size="small"
                            onChange={(e) => {
                              handleCategoryNameChange(
                                categoryIndex,
                                e.target.value as string
                              );
                            }}
                          />
                          <IconButton
                            onClick={() => {
                              handleOpenCategoryDelete(categoryIndex);
                            }}
                          >
                            <DeleteIcon
                              id="delete-category"
                              fontSize="medium"
                              color="primary"
                            />
                          </IconButton>
                          <Dialog
                            open={
                              deleteCategoryIs.categoryIndex === categoryIndex
                            }
                            onClose={handleCloseCategoryDelete}
                            // style={{width:"45rem"}}
                            sx={{
                              m: 1,
                              "& .MuiDialog-paper": {
                                width: "30rem",
                              },
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "flex-end",
                              }}
                            >
                              <IconButton
                                onClick={() => handleCloseCategoryDelete()}
                              >
                                <CloseIcon />
                              </IconButton>
                            </Box>
                            <DialogTitle>Confirmation</DialogTitle>
                            <DialogContent>
                              <Typography>Do you want to delete?</Typography>
                            </DialogContent>
                            <DialogActions>
                              <Button
                                id="no"
                                onClick={handleCloseCategoryDelete}
                              >
                                No
                              </Button>
                              <Button
                                id="yes"
                                variant="contained"
                                onClick={() => {
                                  deleteCategory(categoryIndex);
                                  handleCloseCategoryDelete();
                                }}
                              >
                                Yes
                              </Button>
                            </DialogActions>
                          </Dialog>
                        </Box>
                        <Box>
                          {category.questions.map((question, questionIndex) => {
                            return (
                              <Box sx={{ m: 4 }} key={questionIndex}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      width: "70%",
                                    }}
                                  >
                                    <InputLabel
                                      sx={{
                                        width: "10rem",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Question {questionIndex + 1} :
                                    </InputLabel>
                                    <TextField
                                      id={`question-${questionIndex}`}
                                      size="small"
                                      fullWidth
                                      multiline
                                      maxRows={4}
                                      sx={{ overflow: "auto" }}
                                      value={question.question}
                                      required
                                      variant="standard"
                                      onChange={(e) => {
                                        handleQuestionChange(
                                          categoryIndex,
                                          questionIndex,
                                          e.target.value as string
                                        );
                                      }}
                                    />
                                  </Box>
                                  <Box sx={{ m: 2 }}>
                                    <Select
                                      id="question-type"
                                      disabled
                                      size="small"
                                      value={question.answer_type}
                                      sx={{
                                        height: "2.5rem",
                                        width: "10.5rem",
                                      }}
                                      onChange={(e) => {
                                        editQuestionType(
                                          categoryIndex,
                                          questionIndex,
                                          e.target.value as string
                                        );
                                      }}
                                    >
                                      <MenuItem
                                        id="short-answer"
                                        value="short_answer"
                                      >
                                        Short Answer
                                      </MenuItem>
                                      <MenuItem
                                        id="multichoice"
                                        value="multichoice"
                                      >
                                        Multichoice
                                      </MenuItem>
                                    </Select>
                                    <IconButton
                                      onClick={() => {
                                        handleOpenQuestionDelete(
                                          categoryIndex,
                                          questionIndex
                                        );
                                      }}
                                    >
                                      <DeleteIcon
                                        fontSize="medium"
                                        color="primary"
                                      />
                                    </IconButton>
                                    <Dialog
                                      open={
                                        deleteQuestionIs.categoryIndex ===
                                          categoryIndex &&
                                        deleteQuestionIs.questionIndex ===
                                          questionIndex
                                      }
                                      onClose={handleCloseQuestionDeleter}
                                      // style={{width:"45rem"}}
                                      sx={{
                                        m: 1,
                                        "& .MuiDialog-paper": {
                                          width: "30rem",
                                        },
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                          alignItems: "flex-end",
                                        }}
                                      >
                                        <IconButton
                                          onClick={() =>
                                            handleCloseQuestionDeleter()
                                          }
                                        >
                                          <CloseIcon />
                                        </IconButton>
                                      </Box>
                                      <DialogTitle>Confirmation</DialogTitle>
                                      <DialogContent>
                                        <Typography>
                                          Do you want to delete?
                                        </Typography>
                                      </DialogContent>
                                      <DialogActions>
                                        <Button
                                          id="no"
                                          onClick={handleCloseQuestionDeleter}
                                        >
                                          No
                                        </Button>
                                        <Button
                                          id="yes"
                                          variant="contained"
                                          onClick={() => {
                                            deleteQuestion(
                                              categoryIndex,
                                              questionIndex
                                            );
                                            handleCloseQuestionDeleter();
                                          }}
                                        >
                                          Yes
                                        </Button>
                                      </DialogActions>
                                    </Dialog>
                                  </Box>
                                </Box>
                                <Box>
                                  {question.answer_type === "multichoice" && (
                                    <Container sx={{ p: 1 }}>
                                      {question.answer_choices.map(
                                        (answerChoice, index) => (
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                            key={index}
                                          >
                                            <Radio size="small" disabled />
                                            <TextField
                                              id={`answer_choices-category${categoryIndex}-question${questionIndex}-${index}`}
                                              // label="Standard"
                                              fullWidth
                                              multiline
                                              maxRows={4}
                                              sx={{
                                                overflow: "auto",
                                                m: 1,
                                              }}
                                              size="small"
                                              variant="standard"
                                              value={answerChoice.answer_value}
                                              disabled
                                            />
                                            <Chip
                                              label={`${answerChoice.answer_point}`}
                                              variant="filled"
                                            />
                                            <Button
                                              id={`deleteOption-${index}`}
                                              onClick={() =>
                                                deleteOption(
                                                  categoryIndex,
                                                  questionIndex,
                                                  index
                                                )
                                              }
                                            >
                                              <DeleteIcon />
                                            </Button>
                                          </Box>
                                        )
                                      )}
                                      <Box sx={{ display: "flex" }}>
                                        <TextField
                                          id={`answer_value-catrgory-${categoryIndex}-question-${questionIndex}`}
                                          name="answer_value"
                                          variant="standard"
                                          size="small"
                                          multiline
                                          maxRows={4}
                                          sx={{
                                            overflow: "auto",
                                            m: 1,
                                            width: "40%",
                                          }}
                                          value={
                                            optionValue[categoryIndex]?.[
                                              questionIndex
                                            ]?.value
                                          }
                                          onChange={(e) => {
                                            handleSetOptionValue(
                                              categoryIndex,
                                              questionIndex,
                                              e.target.value
                                            );
                                          }}
                                          required={
                                            question.answer_type ===
                                              "multichoice" &&
                                            question.answer_choices.length === 0
                                          }
                                          placeholder="Add an option"
                                          helperText={
                                            answerChoicesError?.[
                                              categoryIndex
                                            ]?.[questionIndex]?.value &&
                                            flag && (
                                              <Typography
                                                color={"error"}
                                                id="minimum-two-options-error"
                                              >
                                                Please give minimum two options.
                                              </Typography>
                                            )
                                          }
                                        />
                                        <NumberInput
                                          key={forceUpdateKey}
                                          aria-label="Demo number input"
                                          placeholder="Type a number…"
                                          value={
                                            answerWeight[categoryIndex]?.[
                                              questionIndex
                                            ]?.value
                                          }
                                          min={0}
                                          max={100}
                                          onChange={(e: any, val: number) => {
                                            e.preventDefault();
                                            handleSetAnswerChoiceWeight(
                                              categoryIndex,
                                              questionIndex,
                                              val as number
                                            );
                                          }}
                                        />
                                        <Button
                                          id={`add-option`}
                                          size="small"
                                          onClick={() =>
                                            addOption(
                                              categoryIndex,
                                              questionIndex
                                            )
                                          }
                                          sx={{ m: 1 }}
                                        >
                                          Add Option
                                        </Button>
                                      </Box>
                                    </Container>
                                  )}
                                </Box>
                              </Box>
                            );
                          })}
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "right",
                              m: 1,
                            }}
                          >
                            <Button
                              id="addQuestion"
                              variant="outlined"
                              onClick={() => addQuestion(categoryIndex)}
                              size="small"
                            >
                              {/* <AddCircleOutlineIcon /> */}
                              Add Question
                            </Button>
                          </Box>
                        </Box>
                      </Box>
                    </Card>
                  );
                })}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "right",
                    m: 2,
                  }}
                >
                  <Button
                    id="addCategory"
                    variant="contained"
                    size="small"
                    onClick={(e) => {
                      addCategory();
                    }}
                  >
                    Add Category
                  </Button>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                display: { xs: "block", sm: "block", md: "flex" },
                justifyContent: "center",
              }}
            >
              <Box id="employee_date_picker" sx={{ m: 1, p: 1 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    data-testid="employee_date_pick"
                    className="emp_date_picker"
                    label="Employee DeadLine"
                    value={empDate}
                    disablePast
                    format="YYYY-MM-DD"
                    onChange={(newValue) => {
                      setEmpDate(newValue);
                      setManagerDate(newValue?.add(1, "day") as Dayjs);
                    }}
                  />
                </LocalizationProvider>
              </Box>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button id="CreateFormButton" variant="contained" type="submit">
                Create Form
              </Button>
            </Box>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default ThreeSixtyForm;
